<div class="container-full" style="margin-top:10px;">
    <app-header-title-lot-data
    [title]="'Generate MI Prelims'"
    [lotNumber]="_appGeneralState.currentLotNumber"
    [lotName]="_appGeneralState.currentLotName"
></app-header-title-lot-data>
    
    <mat-card style="margin-top:30px;margin-left:10px;margin-right:0px;width:99%;height:90%;min-height: 600px;">
        <mat-card-header>
        
        </mat-card-header>    
        <mat-card-content>

            <div class="row">
                <div class="col-11">
                    <span style="font-size:18px;"><strong>Select a Parker or Company.</strong></span><br /><br />
                    <mat-button-toggle-group name="fontStyle" aria-label="Font Style" [(ngModel)]="currentSearchType" (click)="evalCompanyOrParkerSelection()">
                        <mat-button-toggle value="parker" checked>Parker</mat-button-toggle>
                        <mat-button-toggle value="company">Company</mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
                <div class="col-9">
                    
                </div>
            </div>
            


            <ng-container *ngIf="currentSearchType == 'parker'">
                <div class="row" style="margin-top:20px;">
                    <div class="col-6">
                                                <ng-container *ngIf="!isParkerListLoading; else parkerLoadingTpl">
                                                        <mat-form-field appearance="fill" style="width:99%;color:gray">
                                                                <mat-label>Parker:</mat-label>
                                                                <mat-select [(ngModel)]="selectedParkerId" (selectionChange)="onParkerSelectionChange()">
                                                                    <mat-option value="ALL">Select a Parker</mat-option>
                                                                    <mat-option *ngFor="let parker of parkerList" [value]="parker.parkerId" >
                                                                     {{parker.lastName}}, {{parker.firstName}}
                                                                    </mat-option>
                                                                </mat-select>
                                                            </mat-form-field>
                                                </ng-container>
                                                <ng-template #parkerLoadingTpl>
                                                    <div style="display:flex;justify-content:flex-start;align-items:center;min-height:56px;">
                                                                <mat-progress-spinner mode="indeterminate" diameter="32"></mat-progress-spinner>
                                                        </div>
                                                </ng-template>
                    </div>

                    <div class="col-6">
                        <div style="margin-left:10px;">
                            <strong>
                                @if(this.selectedParkerId != 'ALL' && this.selectedParker){
                                {{selectedParker.lastName}}, {{selectedParker.firstName}}
                               
                                @if(selectedParker.address != ''){
                                    <br />{{selectedParker.address}}
                                }
                                @if(selectedParker.addressLine != ''){
                                    <br />{{selectedParker.addressLine}}
                                }
                                @if(selectedParker.city != ''){
                                    <br />{{selectedParker.city}}
                                }
                                @if(selectedParker.state != ''){
                                    {{selectedParker.state}}
                                }
                                @if(selectedParker.zipCode != ''){
                                    {{selectedParker.zipCode}}
                                 @if(selectedParker.emailAddress != '' || selectedParker.phone != ''){
                                    <br />{{selectedParker.emailAddress}}    {{selectedParker.phone}}
                                } 
                            }
                                }
                                @else{
                                    <div style="margin-top:15px;margin-left:5px;">
                                        <span>Select a Parker</span>
                                    </div>
                            }
                        </strong>
                    </div>
                        </div>
                    </div>


            </ng-container>

            <ng-container *ngIf="currentSearchType != 'parker'">
                <div class="row" style="margin-top:20px;">
                    <div class="col-6">
                        <ng-container *ngIf="!isCompanyListLoading; else companyLoadingTpl">
                            <mat-form-field appearance="fill" style="width:99%;color:gray">
                                <mat-label>Company:</mat-label>
                                <mat-select [(ngModel)]="selectedCompanyId" (selectionChange)="onCompanySelectionChange()">
                                <mat-option value="ALL">Select a Company</mat-option>
                                <mat-option *ngFor="let company of companyList" [value]="company.companyId" >
                                {{company.companyName}}
                                </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </ng-container>
                        <ng-template #companyLoadingTpl>
                            <div style="display:flex;justify-content:flex-start;align-items:center;min-height:56px;">
                                <mat-progress-spinner mode="indeterminate" diameter="32"></mat-progress-spinner>
                            </div>
                        </ng-template>
                    </div>

                    <div class="col-6">
                            <div style="margin-left:10px;">
                                <strong>
                                @if(this.selectedCompanyId != 'ALL' && this.selectedCompany){
                                    {{selectedCompany.companyName}}  
                                    
                                    @if(selectedCompany.address != ''){
                                        <br />{{selectedCompany.address}}
                                    }
                                    @if(selectedCompany.addressLine != ''){
                                        <br />{{selectedCompany.addressLine}}
                                    }
                                    @if(selectedCompany.city != ''){
                                        <br />{{selectedCompany.city}}
                                    }
                                    @if(selectedCompany.state != ''){
                                        {{selectedCompany.state}}
                                    }
                                    @if(selectedCompany.zipCode != ''){
                                        {{selectedCompany.zipCode}}
                                    @if(selectedCompany.emailAddress != '' || selectedCompany.phone != ''){
                                        <br /> {{selectedCompany.emailAddress}}    {{selectedCompany.phone}}
                                    } 
                                }
                                }
                                @else{
                                    <div style="margin-top:15px;margin-left:5px;">
                                        <span>Select a Company</span>
                                    </div>
                                }
                            </strong>
                        </div>
                    </div>
                  </div>
            </ng-container>

            <form 
            (ngSubmit)="onGenerateMiPrelims()" 
            novalidate
            [formGroup]="preLimMiForm" 
            style="margin-top:10px;">
        <div class="row" style="width:100%;">
             <div class="col-3">
                        <mat-form-field appearance="fill" style="width:100%">
                            <mat-label>Invoice Date</mat-label>
                            <input matInput [matDatepicker]="invoiceDatePIcker" formControlName="invoiceDate" placeholder="Invoice Date"  autocomplete="chrome-off" id="invoiceDate">
                            <mat-datepicker-toggle matIconSuffix [for]="invoiceDatePIcker" ></mat-datepicker-toggle>
                            <mat-datepicker #invoiceDatePIcker></mat-datepicker>
                        </mat-form-field>
            </div>
             <div class="col-3">
                    <mat-form-field appearance="fill" style="width:100%">
                        <mat-label>Due Date</mat-label>
                        <input matInput [matDatepicker]="dueDate" formControlName="dueDate" id="dueDate" autocomplete="chrome-off" [readonly]="invoiceSystemDefaults?.miInvoiceDueDateIsReadOnly">
                        <mat-datepicker-toggle matIconSuffix [for]="dueDate" [disabled]="invoiceSystemDefaults?.miInvoiceDueDateIsReadOnly"></mat-datepicker-toggle>
                        <mat-datepicker #dueDate [disabled]="invoiceSystemDefaults?.miInvoiceDueDateIsReadOnly"></mat-datepicker>
                    </mat-form-field>
            </div>
        </div>

        

        @if(targetForInvoiceSelected){
            <app-mi-new-invoice-line
                [taxRateList]="activeTaxListForLot" 
                [lotNumber]="currentLotNumber" 
                [revTypes]="revenueTypes" 
                [invoiceSettings]="invoiceCreationSettings" 
                (newInvoiceLineEvent)="handleAddNewInvoiceLine($event)"
            ></app-mi-new-invoice-line>
        }
        @else{
            <div style="margin-top:20px;margin-left:10px;">
                <span><strong>Select Company or Parker before adding invoice billing lines</strong></span>
            </div>
        }

        
                

    <div style="margin-top:30px;"></div>

     
    @for (item of miFormData; track item.revenueCode + '-' + $index; let idx = $index) {
        
        <div style="margin-left:200px;margin-right:20px;">
            <div>
            @if(idx == 0){    
                <div class="row">
                <div class="col-12 text-end"  style="background-color:#002F87;height:50px;">
                    <div style="margin-top:10px;">
                    <span style="color:white;font-size:21px;" class="ace-heading-text-secondary">Invoice Details</span>
                    </div>
                </div>
                 </div>
           
                <div class="row" style="border-bottom: 1px black solid;">
                    <div class="col-1">
                        
                    </div>
                     <div class="col-1 text-center">
                        <strong>Qty</strong>
                    </div>
                    <div class="col-1 text-center">
                        <strong>Rate</strong>
                    </div>
                    <div class="col-1  text-center">
                        <strong>Rev Type</strong>
                    </div>
                    <div class="col-3  text-center">
                        <strong>Description</strong>
                    </div>
                    <div class="col-1 text-center">
                        <strong>Seq Start</strong>
                    </div>
                    <div class="col-1 text-center">
                        <strong>Seq End</strong>
                    </div>
                  
                    <div class="col-1 text-center">
                        <strong>Amount</strong>
                    </div>
                    <div class="col-1 text-center">
                        <strong>Tax</strong>
                    </div>
                    <div class="col-1 text-center">
                        <strong>Totals</strong>
                    </div>
                </div>
            }
            <div class="row" style="border-bottom: 1px solid black;">
                <div class="col-1">
                    <div class="mimic-button-hover">
                    <span class="material-icons" (click)="onDeleteInvoiceLine(idx)" matTooltip="Delete this Manual Invoice Billing Line Item">
                        delete
                    </span>
                    </div>
                </div>
                <div class="col-1 text-center">
                    {{item.quantity | number}}
                </div>
                <div class="col-1 text-end">
                    {{item.lotParkingRate | currency}}
                </div>
                <div class="col-1 text-center">
                    {{item.revenueType}}
                </div>
                <div class="col-3">
                    {{item.description}}
                </div>
                <div class="col-1 text-center">
                    {{item.sequenceStart}}
                </div>
                <div class="col-1 text-center">
                    {{item.sequenceEnd}}
                </div>
                <div class="col-1 text-end">
                    {{item.netAmount | currency}}
                </div>
                <div class="col-1 text-end">
                    {{item.taxAmount | currency}}
                </div>
                <div class="col-1 text-end">
                    {{item.totalAmount| currency}}
                </div>
            </div>
            </div>

            @if ($last) {
                <div class="row" style="margin-top:10px;">
                    <div class="col-8"></div>
                    <div class="col-1 text-end">
                        <strong>Subtotal:</strong> 
                    </div>
                    <div class="col-1 text-end" style="border: 1px black solid;">
                        <strong>{{displaySubtotal | currency}}</strong> 
                    </div> 
                    <div class="col-1 text-end" style="border: 1px black solid;">
                        <strong>{{displayTotalTax | currency}}</strong> 
                    </div>
                    
                    <div class="col-1 text-end"  style="border: 1px black solid;">
                        <strong>{{displayGrandTotal | currency}}</strong> 
                    </div>
                </div>
            }
        </div>
        } 

     <div style="margin-left:20px;margin-top:30px;">
        <mat-form-field appearance="fill" style="width:100%;color:gray">
            <mat-label>Invoice Description</mat-label>
            <textarea matInput placeholder="Invoice Description" autocomplete="chrome-off" maxlength="1024" formControlName="description" rows="7"></textarea>
         </mat-form-field>
     </div> 

    @if(miFormData.length > 0 && targetForInvoiceSelected)
    {
        <div class="row">
            <div class="col-3">
                <button type="button" class="btn btn-primary mt-3 ace-blue" style="margin-left:20px;" 
                    [disabled]="(miFormData.length == 0) || (targetForInvoiceSelected !== true)"
                    (click)="onGenerateMiPrelimInvoice()"
                    >
                Preview</button>
                <button type="button" class="btn btn-primary mt-3 ace-blue" style="margin-left:10px;" 
                    [disabled]="(miFormData.length == 0) || (targetForInvoiceSelected !== true)"
                    (click)="onGenerateAndFinalizeInvoice()"
                    >
                Finalize</button>
            </div>    

            <div style="margin-top:30px;margin-left:20px;">
                <strong>Click Preview Button to Create Preliminary MI Invoices </strong>
            </div>
        </div>
    } 


     <!-- END INVOICE LINES ADDED FOR MI -->